import * as React from 'react';
import { IRecentItemsNode } from '../graphql/useMainDirectoryEntryWizardsQuery';

interface IWizardOptions extends IRecentItemsNode {
    entryID: string;
}

export type exportType = 'Text' | 'CSV' | 'PDF' | 'XML' | 'TXT' | 'HTML';

export interface IEntryDirectoryEvents {
    newEntry: () => Promise<void>;
    openEntry: (entryID: number) => void;
    checkInEntry: (entryID: number) => void;
    checkOutEntry: (entryID: number) => void;
    addNote: (entryID: number) => void;
    runWizard: (options: IWizardOptions) => void;
    openEntryActionsPopup: (entryID: number) => void;
    openActionsPopup: () => void;
    runExport: (type: exportType) => void;
    manageDynamicLists: () => void;
    manageSavedLists: () => void;
    saveSelected: () => void;
}

const EntryDirectoryContext = React.createContext<IEntryDirectoryEvents>({
    newEntry: () => Promise.resolve(),
    openEntry: () => {
        /* do nothing */
    },
    checkInEntry: () => {
        /* do nothing */
    },
    checkOutEntry: () => {
        /* do nothing */
    },
    addNote: () => {
        /* do nothing */
    },
    runWizard: () => {
        /* do nothing */
    },
    openEntryActionsPopup: () => {
        /* do nothing */
    },
    openActionsPopup: () => {
        /* do nothing */
    },
    runExport: () => {
        /* do nothing */
    },
    manageDynamicLists: () => {
        /* do nothing */
    },
    manageSavedLists: () => {
        /* do nothing */
    },
    saveSelected: () => {
        /* do nothing */
    },
});

export const EntryDirectoryProvider = EntryDirectoryContext.Provider;

export const useEntryDirectoryEvents = () => React.useContext<IEntryDirectoryEvents>(EntryDirectoryContext);
